import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import './index.css'
import CssBaseline from '@mui/material/CssBaseline'
// Import ThemeLayoutProvider instead of direct ThemeProvider
import { ThemeLayoutProvider } from './contexts/ThemeLayoutContext'
// Import axios config to apply interceptors globally
import './utils/axiosConfig.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeLayoutProvider>
          <CssBaseline />
          <App />
        </ThemeLayoutProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
